export enum AddressNextEnum {
  FIND = 'Find',
  RETRIEVE = 'Retrieve'
}
